import { render, staticRenderFns } from "./VaffDurationField.vue?vue&type=template&id=18e712a1&scoped=true&"
import script from "./VaffDurationField.vue?vue&type=script&lang=js&"
export * from "./VaffDurationField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e712a1",
  null
  
)

export default component.exports